import { Image, Button, Dropdown } from 'react-bootstrap';
import { IMAGE_PATHS } from 'constants/imagePaths';
import useCommonStore, { setModalConfig } from 'store/common';
import { useFollowHashtagMutation, useReportMutation } from 'services';
import { useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import useUserStore from 'store/user';
import useTranslate from 'hooks/useTranslate';
import './styles.scss';

const HashTagHeader: React.FC<any> = ({ data, refetchData }) => {
	const { translate } = useTranslate();
	const { isFollowed, id, totalFollowers, name } = data || {};
	const { mutateAsync: followHashtagMutation } = useFollowHashtagMutation();
	const { mutateAsync: reportProfileMutation } = useReportMutation();
	const { id: contentId } = useParams();
	const { hideCommonModal }: any = useCommonStore((state) => state);
	const { followedHashTags = [], setFollowedHashTags }: Record<string, any> = useUserStore(
		(state) => state,
	);
	const reportProfile = () => {
		setModalConfig({
			visible: true,
			id: contentId,
			onClick: reportProfileFunction,
			type: 'reportFeeds',
			contentType: 'socialHashtag',
		});
	};

	const reportProfileFunction = (values: any) => {
		reportProfileMutation({ ...values, contentId: Number(values?.contentId) })
			.then((res: any) => {
				if (res?.success) {
					toast.success(
						translate(`Profile.profileReported`, { field: translate('Report.hashtag') }),
					);
				}
				hideCommonModal();
			})
			.catch((error) => {
				console.error('Failed to report profile:', error);
				toast.error(translate('Common.reportFailed')); // Notify the user of the failure
				hideCommonModal(); // Optionally hide the modal even on error
			});
	};

	const unFollowAccount = () => {
		followHashtagMutation(parseInt(id))
			.then((res: any) => {
				if (res?.success) {
					const hashTagData = followedHashTags.filter((res: any) => res?.id !== data?.id);
					setFollowedHashTags(hashTagData);
					refetchData();
				}
			})
			.finally(() => {
				hideCommonModal();
			});
	};

	const doFollowUnfollow = () => {
		if (isFollowed === 1) {
			setModalConfig({
				visible: true,
				type: 'confirmModal',
				onClick: unFollowAccount,
				data: {
					title: translate('Modal.wantToUnfollow', { title: `${translate('Modal.hash')}` }),
				},
				props: {
					dialogClassName: 'confirm-modal',
				},
			});
		} else {
			followHashtagMutation(parseInt(id))
				.then((res: any) => {
					if (res?.success) {
						const newHashTags = [...followedHashTags, { ...data, hashTag: data?.name }];
						setFollowedHashTags(newHashTags);
						refetchData();
					} else {
						toast.error(
							res?.message ||
								translate('ToastMessage.failedToFollowTitle', {
									title: translate('Social.hashtag'),
								}),
						); // Handle unsuccessful response
					}
				})
				.catch((error) => {
					console.error('Failed to follow hashtag:', error);
					toast.error(
						translate('ToastMessage.failedToFollowTitle', {
							title: translate('Social.hashtag'),
						}),
					);
				});
		}
	};

	return (
		<div className="white-box bg-white hashtag-detail">
			<div className="social-post-header position-relative d-flex justify-content-between align-items-md-center gap-3">
				<div className="post-profile d-flex flex-column flex-md-row align-items-md-center gap-3">
					<div className="post-profile-img rounded-circle">
						<Image
							src={IMAGE_PATHS.UserBG}
							className="w-100 h-100 object-fit-cover rounded-circle"
							loading="lazy"
						/>
					</div>
					<div>
						<h5 className="fw-bold mb-1">#{name}</h5>
						<div className="post-profile-detail d-flex">
							<p className="mb-0">
								{totalFollowers} {translate('Common.followers')}
							</p>
							{/* {created && <p className="mb-0">{getCreatedDifferenceInBestUnit(created)}</p>} */}
						</div>
					</div>
				</div>

				<div className="post-profile-actions d-flex gap-2 gap-xxl-3">
					<Button onClick={doFollowUnfollow} className="filled-btn rounded-pill follow-btn">
						{' '}
						{isFollowed ? translate('Common.following') : translate('Common.follow')}
					</Button>
					<div className="edit-action">
						<Dropdown>
							<Dropdown.Toggle variant="success" id="dropdown-basic" className="p-0 rounded-circle">
								<i className="ri-more-2-fill"></i>
							</Dropdown.Toggle>

							<Dropdown.Menu>
								<Dropdown.Item onClick={reportProfile}>
									<i className="ri-flag-line"></i> {translate('Report.report')}
								</Dropdown.Item>
							</Dropdown.Menu>
						</Dropdown>
					</div>
				</div>
			</div>
		</div>
	);
};

export default HashTagHeader;
